import React from 'react'
import { FaLinkedinIn, FaGithub, FaChess } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='header_socials'>
      <a href='https://www.linkedin.com/in/mnathuw/' target='_blank' rel="noreferrer"><FaLinkedinIn /></a>
      <a href='https://github.com/mnathuw' target='_blank' rel="noreferrer"><FaGithub /></a>
      <a href='https://www.chess.com/member/mnathu98' target='_blank' rel="noreferrer"><FaChess /></a>
    </div>
  )
}

export default SocialMedia